var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { useRef } from "react";
import InputMask from "react-input-mask";
import { Container, Label, Input, InputContainer, Icon, DropdownWrapper, ErrorWrapper, Chip, ChipText, ChipContainer, ComboContainer, ChipIcon, } from "./TextInput.styles";
import { DropDown } from "../DropDown";
import { useField, useFormikContext } from "formik";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Check from "../assets/TextInput/check.svg";
import Close from "../assets/TextInput/close.svg";
import { Paper } from "@material-ui/core";
var idNum = 0;
var CustomPaper = function (props) {
    if (props.style) {
        props.style.marginTop = "0px";
    }
    return React.createElement(Paper, __assign({}, props, { style: { margin: "0px" } }));
};
export var TextInput = function (_a) {
    var _b = _a.label, label = _b === void 0 ? "" : _b, _c = _a.mask, mask = _c === void 0 ? "" : _c, _d = _a.dropDown, dropDown = _d === void 0 ? [] : _d, _e = _a.options, options = _e === void 0 ? [] : _e, dropDownName = _a.dropDownName, _f = _a.icon, icon = _f === void 0 ? "" : _f, setFieldValue = _a.setFieldValue, _g = _a.multiple, multiple = _g === void 0 ? false : _g, props = __rest(_a, ["label", "mask", "dropDown", "options", "dropDownName", "icon", "setFieldValue", "multiple"]);
    var _h = __read(useField(props), 2), field = _h[0], meta = _h[1];
    var inputRef = useRef(null);
    if (!setFieldValue)
        setFieldValue = useFormikContext().setFieldValue;
    var inputId = props.id ||
        "input-" + (label || (idNum++).toString()).replace(/\s+/g, "").trim();
    var containerId = inputId + "-Container";
    var listId = inputId + "-List";
    var handleContainerClick = function (event) {
        var target = event.target;
        if (target.id.startsWith(containerId)) {
            focusInput();
        }
    };
    var handleIconClick = function () {
        focusInput();
    };
    var focusInput = function () {
        var _a;
        if (inputRef.current)
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var onChange = field.onChange, optionsField = __rest(field, ["onChange"]);
    var handleRemove = function (index) {
        if (Array.isArray(field.value)) {
            var array = field.value;
            array.splice(index, 1);
            if (setFieldValue)
                setFieldValue(props.name, array);
        }
    };
    var iconWidth = "24px";
    var autoCompleteStyle = {
        width: icon !== "" ? "calc(100% + " + iconWidth + ")" : "100%",
        marginLeft: icon !== "" ? "calc(-" + iconWidth + ")" : undefined,
    };
    return (React.createElement(Container, null,
        label ? (React.createElement(Label, { htmlFor: props.name },
            label,
            meta.error && meta.touched ? (React.createElement(ErrorWrapper, { id: containerId + "-Error" }, meta.error)) : null)) : meta.error && meta.touched ? (React.createElement(ErrorWrapper, { id: containerId + "-Error" }, meta.error)) : null,
        React.createElement(InputContainer, { onClick: handleContainerClick, id: containerId },
            icon !== "" ? React.createElement(Icon, { src: icon, onClick: handleIconClick }) : null,
            options.length !== 0 ? (React.createElement(Autocomplete, __assign({ id: inputId + "-Autocomplete", options: __spread(options), onChange: function (_event, value) {
                    if (setFieldValue)
                        setFieldValue(props.name, value || "");
                }, style: autoCompleteStyle, multiple: multiple, PaperComponent: CustomPaper }, optionsField, { value: field.value || null, renderInput: function (params) {
                    return (React.createElement(ComboContainer, { ref: params.InputProps.ref },
                        Array.isArray(field.value) && field.value.length ? (React.createElement(ChipContainer, { style: {
                                marginLeft: icon ? iconWidth : undefined,
                            } }, field.value.map(function (name, index) {
                            return (React.createElement(Chip, { key: name + index },
                                React.createElement(ChipIcon, { src: Check }),
                                React.createElement(ChipText, null, name),
                                React.createElement(ChipIcon, { style: { cursor: "pointer" }, src: Close, onClick: function () { return handleRemove(index); } })));
                        }))) : null,
                        React.createElement(Input, __assign({ style: {
                                marginLeft: icon && !(multiple && field.value.length)
                                    ? iconWidth
                                    : undefined,
                            }, ref: inputRef, list: listId }, params.inputProps, props))));
                } }))) : (React.createElement(React.Fragment, null, mask === "" ? (React.createElement(Input, __assign({ ref: inputRef, list: listId }, field, props))) : (React.createElement(InputMask, __assign({ mask: mask }, field, props), function (inputProps) { return (React.createElement(Input, __assign({ list: listId }, inputProps, { ref: inputRef }))); })))),
            dropDown.length !== 0 ? (React.createElement(DropdownWrapper, null,
                React.createElement(DropDown, { name: dropDownName || props.name + "Dropdown", data: dropDown, height: 34, setFieldValue: setFieldValue, textInput: true }))) : null)));
};
//# sourceMappingURL=TextInput.js.map